<template>
    <div v-motion :initial="initial" :visible="visible">
        <slot></slot>
    </div>       
</template>

<script setup>


const initial = ref({
    opacity: 0,
    y: 50,
    filter: 'blur(20px)',
});

const visible = ref({
        y: 0,
        opacity: 1,
        filter: 'blur(0px)',
        transition: {            
            delay: 200,
            type: 'spring',
            stiffness: 100,
            damping: 25,
            mass: 0.5,
        },
    });
</script>